/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, OnInit } from '@angular/core';
import {
  PatchNotesService,
  PatchNoteIndexEntry,
  PatchNoteVersion
} from '../../services/patch-notes/patch-notes.service';

@Component({
  selector: 'wsn-patch-notes',
  templateUrl: './patch-notes.component.html',
  styleUrls: ['./patch-notes.component.scss']
})
export class PatchNotesComponent implements OnInit {
  index: PatchNoteIndexEntry[] = [];
  selectedVersion = '';
  notes: PatchNoteVersion | null = null;
  loading = true;
  error = false;

  constructor(private patchNotesService: PatchNotesService) {}

  ngOnInit(): void {
    this.patchNotesService.getIndex().subscribe({
      next: (index) => {
        this.index = index;
        if (index.length > 0) {
          this.loadVersion(index[0].version);
        } else {
          this.loading = false;
        }
      },
      error: () => {
        this.loading = false;
        this.error = true;
      }
    });
  }

  loadVersion(version: string): void {
    this.selectedVersion = version;
    this.loading = true;
    this.error = false;
    this.patchNotesService.getVersion(version).subscribe({
      next: (notes) => {
        this.notes = notes;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.error = true;
      }
    });
  }
}
